<template>
<div class="goods" v-loading.fullscreen.lock="loading">
  <latestnews></latestnews>
  <pricelist :title="'出售大厅'" :data="goodList" :page="goodsPage" @showlogin="showLogin"
  @changepage="changeGoodsPage" @changepagesize="changeGoodsPageSize"></pricelist>
</div>

</template>

<script>
import latestnews from '@/components/common/latestnews/latestNews'
import pricelist from '@/components/common/pricelist/priceList'
import { saleResource } from '@/resource/resource'
import { mapState } from 'vuex'

const ERR_OK = 0

export default {
  name: 'goods',
  props: {
    searchdata: {
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      goodList: [],
      goodsPage: {
        'page_current': 1,
        'page_size': 20,
        'total_count': 0,
        'total_page': 1
      },
      goods_page_size: 10,
      s_params: {}
    }
  },
  computed: {
    ...mapState(['userInfo', 'logined', 'config_info'])
  },
  created() {
    // console.log(this.$route.query)
    this.init()
    // Object.assign(this.s_params, this.$route.query)
    // this.goods_page_size = this.config_info.service_sell_limit
    // this.s_params.count = this.goods_page_size
    // this.s_params.type = 1
    // this.getGoodList(this.s_params)
  },
  // mounted () {
  //   console.log(this.$route.query)
  // },
  watch: {
    '$route.query' (val, oldVal) {
      if (val !== oldVal) {
        this.s_params = {}
        this.init()
      }
    }
  },
  methods: {
    init() {
      Object.assign(this.s_params, this.$route.query)
      this.goods_page_size = this.config_info.service_sell_limit
      this.s_params.count = this.goods_page_size
      this.s_params.type = 1
      this.getGoodList(this.s_params)
    },
    getGoodList (params) {
      this.loading = true
      saleResource.list(params).then(res => {
        res = res.body
        this.loading = false
        if (res.errcode === ERR_OK) {
          this.goodList = res.data
          this.goodsPage = res.page
        }
      })
    },
    changeGoodsPage(val) {
      this.s_params.page = val - 1
      this.getGoodList(this.s_params)
    },
    changeGoodsPageSize(size) {
      this.goods_page_size = size
      this.s_params.count = this.goods_page_size
      this.s_params.page = 0
      this.getGoodList(this.s_params)
    },
    showLogin() {
      this.$emit('showlogin', true)
    }
  },
  components: {
    latestnews,
    pricelist
  }
}
</script>

<style lang="stylus" scoped>
.goods
  width 1000px
  margin 0 auto
</style>




// WEBPACK FOOTER //
// goods.vue?c437091e